import hotkey, { type THotkey } from '@atlas/tool/box/event/hotkey';
import Label from '@atlas/uicorn/lib/Display/Label';
import * as React from 'react';
import styled from 'styled-components';

const HotkeyLabel = React.memo(function HotkeyLabel(props: THotkeyLabelProps): React.ReactElement {
    const { hotkey, ...elementProps } = props;

    return (
        <SHotkeyLabel color="grey52" {...elementProps}>
            {hotkey.toString()}
        </SHotkeyLabel>
    );
});

export default HotkeyLabel;

// #region Styles

const SHotkeyLabel = styled(Label)`
    color: ${(p) => p.theme.color.grey8};
`;

// #endregion

// #region Types

export type THotkeyLabelProps = Omit<React.HTMLAttributes<HTMLDivElement>, 'children' | 'color'> & {
    hotkey: THotkey;
};

// #endregion

// #region Examples

export function Example() {
    return <HotkeyLabel hotkey={hotkey('shift+alt+a', 'hidden')} />;
}

// #endregion

// #region Tests

if (import.meta.vitest) {
    const { describe, it, expect } = import.meta.vitest;
    describe('HotkeyLabel', async () => {
        const testModule = '@test';
        const { render } = await import(/* @vite-ignore */ testModule);

        it('matches snapshot', () => {
            const result = render(<Example />);
            expect(result.container).toMatchSnapshot();
        });
    });
}

// #endregion
